import {
  camelCase,
  cloneDeep,
  forEach,
  isNull,
} from "lodash-es";

import PuxTablePlugin from "../plugin/PuxTablePlugin.js";


export default function UtilsAPI() {
  const {
    checkContextTypeSync,
    checkPermissionsSync,
  } = PuxTablePlugin.PermissionAPI();

  const removePrefix = ({ key, prefix }) => {
    // PREFIX_id behält Prefix, um Konflikt mit id-Feld zu vermeiden
    if (key === `${ prefix }_id`) {
      return key;
    }
    const REGEX = new RegExp(`^${ prefix }_`);
    return key.replace(REGEX, "");
  };

  const changeSnaKeCaseToCamelCase = ({ obj, prefix = "" }) => {
    const NEW_OBJ = {};
    forEach(cloneDeep(obj), (item, key) => {
      const NEW_KEY = removePrefix({ key, prefix });
      NEW_OBJ[camelCase(NEW_KEY)] = isNull(item) ? undefined : item;
    });
    return NEW_OBJ;
  };

  const checkPermissionAndContextType = item => {
    if (item.permission) {
      let statusHasPermission = checkPermissionsSync({ perm: item.permission });
      statusHasPermission = item.permissionMissing ? !statusHasPermission : statusHasPermission;
      if (!statusHasPermission) {
        return false;
      }
    }
    if (item.permissionContextType &&
      !checkContextTypeSync({
        contextType: item.permissionContextType
      })) {
      return false;
    }
    return true;
  };

  return {
    changeSnaKeCaseToCamelCase,
    checkPermissionAndContextType,
  };
}
